var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.items.length)?_c('x-data-table',{attrs:{"caption":"Прочее оборудование","headers":_vm.headers,"items":_vm.items,"hide-default-footer":true}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }